<div [class]="'alert ' + variant + ' ' + size">
  <div class="alert-icon">
    <mat-icon>{{ icon }}</mat-icon>
  </div>
  <div class="alert-text">
    <ng-content></ng-content>
  </div>
</div>
